var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconaCorsi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.604,
    height: 16.6,
    viewBox: "0 0 16.604 16.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona",
    transform: "translate(0.302 0.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2171",
    "data-name": "Tracciato 2171",
    d: "M15.918,341.134a.358.358,0,0,0-.256-.565H2.44a2.44,2.44,0,1,0,0,4.879H15.662a.339.339,0,0,0,.252-.569A2.479,2.479,0,0,1,15.918,341.134Zm-.958,3.633H2.44a1.759,1.759,0,1,1,0-3.518H14.97A2.92,2.92,0,0,0,14.96,344.768Z",
    transform: "translate(0 -329.449)",
    fill: "#4e4e4e",
    stroke: "#4e4e4e",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2172",
    "data-name": "Tracciato 2172",
    d: "M.338,10.439H13.56a2.44,2.44,0,1,0,0-4.879h-7.4V4.878h9.5a.339.339,0,0,0,.252-.569,2.479,2.479,0,0,1,0-3.745A.358.358,0,0,0,15.662,0H2.44a2.44,2.44,0,1,0,0,4.879h.435v.681H.338a.358.358,0,0,0-.256.565,2.48,2.48,0,0,1,0,3.745A.339.339,0,0,0,.338,10.439ZM2.44,4.2A1.759,1.759,0,1,1,2.44.68H14.97A2.921,2.921,0,0,0,14.96,4.2h-8.8V2.439a.34.34,0,0,0-.34-.34H3.215a.34.34,0,0,0-.34.34V4.2ZM5.482,2.779V7.033l-.753-.59a.341.341,0,0,0-.42,0l-.753.59V2.779ZM2.875,6.24V7.732c-.02.3.206.586.551.268l1.094-.857L5.613,8c.358.29.578.017.551-.268V6.24h7.4a1.759,1.759,0,1,1,0,3.518H1.04A2.921,2.921,0,0,0,1.03,6.24H2.875Z",
    fill: "#4e4e4e",
    stroke: "#4e4e4e",
    strokeWidth: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaCorsi);
export default __webpack_public_path__ + "static/media/icona_corsi.e64e64ca14efca4ac86aac6cb79fccc8.svg";
export { ForwardRef as ReactComponent };